import { useLayoutEffect } from 'react';
import './SearchResults.scss';

const SearchResults = () => {
  useLayoutEffect(() => {
    const siteSearchScript = document.createElement('script');

    siteSearchScript.setAttribute('id', 'searchsg-config');
    siteSearchScript.setAttribute(
      'src',
      `https://api.search.gov.sg/v1/searchconfig.js?clientId=${
        process.env.REACT_APP_SITE_SEARCH_CLIENT_ID as string
      }&page=result`,
    );
    siteSearchScript.setAttribute('defer', '');
    document.head.append(siteSearchScript);

    return () => {
      document.head.removeChild(siteSearchScript);
    };
  }, []);

  return <div id="searchsg-result-container" />;
};

export default SearchResults;
